import Query from '../../components/Report';

export default new Query('discover-stats-appearances-chart');

// sql should be start date, end date, domain
